module.exports = __webpack_public_path__ + "img/phone-missed.430decf2.svg";